import QueryResult from '@/common/network/QueryResult';
import ToFormDataSerializationStrategy from '@/common/network/serialization/ToFormDataSerializationStrategy';
import { S3UploadResponse } from '@/common/types/s3UploadResponse';

import CutwiseAPIClient, { METHOD_POST } from '../network/CutwiseAPIClient';

export const PATH_UPLOAD_IMAGE = 'api/upload/image';

// second version of api support png (does not automatically convert them to jpg),
// but does not support url options (see setS3ImageOptions for them)
export const PATH_UPLOAD_IMAGE_V2 = 'api/v2/upload/image';

export default class S3UploadAPI {
  uploadImage(file: File): Promise<QueryResult<S3UploadResponse>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_POST)
      .path(PATH_UPLOAD_IMAGE)
      .body({ auto: file })
      .serializer(ToFormDataSerializationStrategy)
      .suppressErrorNotifications();

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  uploadImageV2(file: File): Promise<QueryResult<S3UploadResponse>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_POST)
      .path(PATH_UPLOAD_IMAGE_V2)
      .body({ auto: file })
      .serializer(ToFormDataSerializationStrategy)
      .suppressErrorNotifications();

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
